import { gql } from '@apollo/client'

const BASE_ADMISSION_EXPERT_FIELDS = gql`
  fragment BaseAdmissionExpertFields on AdmissionExpertType {
    id
    name
    avatar
    degree
    description
    email
    createdAt
    updatedAt
  }
`

export const GET_ADMISSION_EXPERTS = gql`
  ${BASE_ADMISSION_EXPERT_FIELDS}
  query findAllAdmissionExpert($params: AdmissionExpertQueryInput = {}) {
    findAllAdmissionExpert(query: $params) {
      count
      items {
        ...BaseAdmissionExpertFields
        getAvatar {
          photo
        }
      }
    }
  }
`

export const CREATE_ADMISSION_EXPERT = gql`
  ${BASE_ADMISSION_EXPERT_FIELDS}
  mutation createAdmissionExpert($params: CreateAdmissionExpertInput!) {
    createAdmissionExpert(createAdmissionExpertInput: $params) {
      ...BaseAdmissionExpertFields
      getAvatar {
        photo
      }
    }
  }
`

export const UPDATE_ADMISSION_EXPERT = gql`
  ${BASE_ADMISSION_EXPERT_FIELDS}
  mutation updateAdmissionExpert($params: UpdateAdmissionExpertInput!) {
    updateAdmissionExpert(updateAdmissionExpertInputFieldName: $params) {
      ...BaseAdmissionExpertFields
      getAvatar {
        photo
      }
    }
  }
`

export const REMOVE_ADMISSION_EXPERT = gql`
  mutation removeAdmissionExpert($params: String!) {
    removeAdmissionExpert(id: $params) {
      affected
    }
  }
`
